'use strict';

// utility class
import ApplyClass from './Utils/ApplyClass';
import Common from './Utils/Common';
import ControllerObject from './Controller/Controller';

import SmoothScroll from './View/SmoothScroll';
import Header from './View/Header';
import Drawer from './View/Drawer';
import GoTop from './View/GoTop';
import Accordion from './View/Accordion';
import Fade from './View/Fade';
import Slider from './View/Slider';
import AreaManager from './View/AreaManager';
import ChangeDate from './View/ChangeDate';
import FilterArea from './View/FilterArea';
import Filter from './View/Filter';
import Modal from './View/Modal';
import SliderSS from './View/SliderSS';

$(() => {
	const Controller = new ControllerObject();
	Common.addHtmlClass();
	// スムーススクロール
	$('a[href^="#"]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SmoothScroll, $e, [$e, Controller]);
	});
	// ヘッダー
	$('#logo').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Header, $e, [$e, Controller]);
	});
	// スマホメニュー
	$('.btn--sp-menu').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Drawer, $e, [$e, Controller]);
	});
	// TOPに戻るボタン
	$('.anchor--go-top').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GoTop, $e, [$e, Controller]);
	});
	// アコーディオン
	$('.accordion').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Accordion, $e, [$e, Controller]);
	});
	// key visual
	$('.kv-slide').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Fade, $e, [$e, Controller]);
	});
	// バナースライダー
	$('.banner-slide').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Slider, $e, [$e, Controller]);
	});
	// エリアマネージャースライダー
	$('.area-manager-slide').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AreaManager, $e, [$e, Controller]);
	});
	// 日付変更
	$('#wpforms-405 [data-field-id="8"]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDate, $e, [$e, Controller]);
	});
	$('#wpforms-419 [data-field-id="8"]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDate, $e, [$e, Controller]);
	});
	// 絞り込みエリア開閉
	$('.btn--filter-area').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FilterArea, $e, [$e, Controller]);
	});
	// 絞り込み
	$('.btn--filter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Filter, $e, [$e, Controller]);
	});
	// 学校モーダル
	$('[data-toggle=modal]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Modal, $e, [$e, Controller]);
	});
	// サマースクールスライダー
	$('.ss-slide').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SliderSS, $e, [$e, Controller]);
	});
});

